<template>
  <div class="limits-reached-modal">
    <GlBaseModal
      closable
      @close="$emit('close')"
    >
      <template #header>
        Make the most of your plan!
      </template>
      <div>
        <p>
          You are currently using the subscription. You have
          <span class="bold-600">{{ limitInfo.reportsRemaining }}</span> of
          <span class="bold-600"> {{ limitInfo.monthlyQuota }}</span> reports
          remaining.
        </p>

        <p>
          To unlock more capacity and continue generating or refreshing data
          without limits, you can upgrade your subscription today.
        </p>
      </div>
      <template
        v-if="!isB2bUser"
        #footer
      >
        <gl-button
          dark
          full
          size="large"
          title="Activate Full Subscription"
          @click="onActionClick"
        />
      </template>
    </GlBaseModal>
  </div>
</template>

<script>
// components
import GlButton from '@/components/gl-button'
import GlBaseModal from '@/components/modals/GlBaseModal'
//utils
import { openProfilePlan } from '@/utils/go-to-route'
// vuex
import { mapGetters, mapState } from "vuex";

export default {
  name: 'LimitsReachedModal',
  components: {
    GlBaseModal,
    GlButton,
  },
  props: {
    limitInfo: {
      type: Object,
      default: () => ({}),
    },
    targetTier: {
      type: String,
      default: 'pro'
    },
    targetBillingCycle: {
      type: String,
      default: 'annual'
    },
    targetTrialState: {
      type: Boolean,
      default: false
    },
    onlyEmit: {
      type: Boolean,
      default: false
    },
    onConfirmCallback: {
      type: Function,
      default: null
    }
  },
  computed: {
    ...mapGetters('user', ['isB2bUser']),
    ...mapState('payment', ['currentPlan']),
    resolvedTier() {
      const tier = this.currentPlan?.planTier;
      return tier && tier !== 'free' && tier !== 'none' ? tier : this.targetTier;
    },
    resolvedBillingCycle() {
      const cycle = this.currentPlan?.billingCycle;
      return cycle ? cycle : this.targetBillingCycle;
    }
  },
  methods: {
    openProfilePlan,
    onActionClick() {
      if (this.onlyEmit) {
        this.$emit('confirm');

        if (typeof this.onConfirmCallback === 'function') {
          this.onConfirmCallback();
        }

        return;
      }

      if (this.$route.name == 'report') {
        const currentPath = this.$route.fullPath;
        localStorage.setItem('comeBackPath', currentPath);
      } else {
        localStorage.removeItem('comeBackPath');
      }

      this.openProfilePlan({
        planTier: this.resolvedTier,
        billingCycle: this.resolvedBillingCycle,
        isTrialRequest: false,
      });
    },
  },
}
</script>

<style scoped>
.limits-reached-modal {
  background: var(--white, #fff);
  border-radius: 24px;
  width: 100%;
  max-width: 552px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
}
.limits-reached-modal::v-deep .gl-base-modal__header {
  font-size: var(--Size-3XL, 24px);
  font-weight: 700;
  line-height: var(--Line-Height-3XL, 32px);
  padding: 48px 48px 0 48px;
}
.limits-reached-modal::v-deep .gl-base-modal__body {
  font-size: var(--Size-L, 16px);
  font-weight: 500;
  line-height: var(--Line-Height-XL, 24px);
  letter-spacing: var(--Letter-Spacing-XS, -0.5px);
  padding: 16px 48px 32px 48px;
}
.limits-reached-modal::v-deep .gl-base-modal__body p:first-child {
  margin-bottom: 12px;
}
.limits-reached-modal::v-deep .gl-base-modal__footer {
  padding: 0 48px 48px 48px;
}
</style>
